var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.start || _vm.end)?_c('span',{class:`badge ${_vm.badgeStatus}`},[_vm._v(" "+_vm._s(_vm.displayPeriod)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }